import type { ReactNode } from "react";

/**
 * Cabecera de pantalla. Cada pantalla declara la pregunta que responde (D-021): si no se
 * puede escribir en una frase, la pantalla todavía no está lista.
 */
export function PageHeader({ title, question, actions }: { title: string; question: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-2xl leading-tight font-semibold tracking-tight text-light">{title}</h1>
        <p className="mt-1.5 text-base text-light-2">{question}</p>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
